// removed by extract-text-webpack-plugin
module.exports = {"Search":"Search--1VyWr","Input":"Input--2GuSI"};